<template>
  <div>
    <iframe v-if="this.$hasConstruction('IEBDC:SY:ZXJF:SFZJ')" :src="returnTrustSrc" class="iframe-style" frameborder="0"></iframe>
    <!--  后台配置权限该功能是否在建  -->
    <no-data v-else :data="dataNo"></no-data>
  </div>
</template>

<script>
  import hasConstruction from '@iebdc/mixin/hasConstruction';
export default {
  mixins: [hasConstruction],
  computed: {
    returnTrustSrc() {
      let trustSrc = window.CONFIG.PAY_PATH;
      if (this.$route.params.orderNo) {
        trustSrc = trustSrc + '?ddh=' + this.$route.params.orderNo;
      }
      return trustSrc;
    }
  },
  data() {
    return {
      dataNo:{
        src: require('@/pages/iebdc/assets/images/nodata@2x.png'),
        imgWidth: '242px',
        imgHeight: '194px',
        title: '敬请期待',
        description: '正在建设中...',
      },
    };
  }
};
</script>

<style scoped>
.iframe-style {
  margin-left: calc(50% - 600px);
  width: 1200px;
  height: 550px;
}
</style>
